export type GenderType = '' | 'femaleDisplay' | 'maleDisplay';

export function isGenderType(value: unknown): value is GenderType {
  return value === '' || value === 'femaleDisplay' || value === 'maleDisplay';
}
